var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-8 max-w-3xl flex-no-grow"},[_c('FullCalendar',{attrs:{"events":_vm.eventSources,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }